module.exports = __webpack_public_path__ + "img/leak_remove.37bea1c3.svg";